﻿import { Button, Stop } from '@core/ui';
import { useTranslation } from 'react-i18next';

interface Props {
    onClick: () => void;
}

export const WebinarButtonEnd = ({ onClick }: Props) => {
    const { t } = useTranslation();

    return (
        <Button type="submit" variant="warning" classNames="group" onClick={onClick}>
            <Stop classNames="w-4 fill-current" />
            <span className="sr-only bc:not-sr-only bc:ml-3">{t('Broadcaster.Button.End')}</span>
        </Button>
    );
};
